import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteConceptForm,
    getConceptFormById,
    saveConceptForm
} from 'app/services/ConceptFormService';
import { ConceptForm } from "app/common/Model/ConceptForm";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { importConceptFormExcel } from "app/services/ImportExcelService";
import { addHealthCheckCampaignManage, getByIdHealthCheckCampaignManage, markDeleteHealthCheckCampaignManage, pagingHealthCheckCampaignManage, synDeleteHealthCheckCampaignManage } from "app/services/HealthCheckCampaignManageService";

export default class HealthCheckCampainStore {
    searchHealthCheck = new SearchObject();
    pageHealthCheck = null;
    selectedHealthCheck = {};
    openFormCreateOrEdit = false;
    openConfirmDelete = null;
    openImportExcel = false;

    constructor() {
        makeAutoObservable(this);
    }
    handleOpenImportExcel = () => {
        this.openImportExcel = true;
    }
    handleCloseImportExcel = () => {
        this.openImportExcel = false;
    };
    saveImportExcelConcept = (file) => {
        importConceptFormExcel(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchHealthCheck = {
                ...this.searchHealthCheck,
                pageIndex: 1
            }
            this.pagingHealthCheck();
            this.openImportExcel = false;
        }).catch(() => {
            toast.error("Nhập excel thất bại")
        }).finally(() => {
            this.handleClosePopup();
        })
    }

    pagingHealthCheck = async (searchObj) => {
        let newSearchObj = { ...this.searchHealthCheck, ...searchObj }
        return await pagingHealthCheckCampaignManage(newSearchObj)
            .then(({ data }) => {
                this.pageHealthCheck = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchHealthCheck) => {
        this.searchHealthCheck = checkSearchObject(this.searchHealthCheck, searchHealthCheck);
        this.pagingHealthCheck();
    }

    handleOpenFormCreateOrEdit = (conceptFormId) => {
        if (Boolean(conceptFormId)) {
            getByIdHealthCheckCampaignManage(conceptFormId)
                .then(({ data }) => {

                    this.selectedHealthCheck = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.openFormCreateOrEdit = true;
        }
    }

    handleSynHealthCheckCampaign = () => {
        synDeleteHealthCheckCampaignManage(this.searchHealthCheck).then(() => {
            toast.success("ĐỒng bộ thành công")
            this.pagingHealthCheck()
        }).catch((error) => {
            toast.error("Đồng bộ thất bại")
        })
    }

    saveConceptForm = async (conceptForm, { setSubmitting }) => {
        return await addHealthCheckCampaignManage(conceptForm).then(() => {
            toast.success("Lưu mẫu kết quả thành công!");
            this.handleClosePopup();
            this.pagingHealthCheck();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin mẫu kết quả có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteConceptForm = (id) => {
        this.openConfirmDelete = id;
    }

    handleConfirmDeleteConceptForm = () => markDeleteHealthCheckCampaignManage(this?.openConfirmDelete)
        .then(() => {
            if (this.searchHealthCheck.pageIndex > 1 && this.pageHealthCheck?.content?.length === 1) {
                this.searchHealthCheck.pageIndex -= 1;
            }
            toast.success("Xóa mẫu kết quả thành công!")
            this.handleClosePopup();
            this.pagingHealthCheck();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa mẫu kết quả có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = null;
        this.openImportExcel = false;
        this.selectedHealthCheck = {}
    }

    resetStore = () => {
        this.searchHealthCheck = new SearchObject();
        this.pageHealthCheck = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.selectedHealthCheck = {}
    }
}